export default function deleteGlobal(globalName) {
  try {
    delete window[globalName]
  } catch (_err) {
    window[globalName] = undefined
  }
}
